import { Button } from 'antd'
import { useState, VFC } from 'react'
import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import { ImportEmployeesPageHeader, ImportEmployeesUploadCvs } from '@/components/pages/Employees/Import'
import { useEmployees } from '@/pages/Employees/Employees.hooks'
import { useImportEmployee } from '@/pages/Employees/Import/Import.hooks'

const ImportEmployee: VFC = () => {
  const { importEmployeeTypeInsert, importEmployeeTypeUpdate, loading } = useImportEmployee()
  const { exportEmployeeInsertExample, exportEmployeeUpdateExample } = useEmployees()
  const [searchParams] = useSearchParams()
  const isInsert = searchParams.get('is_insert')
  const [fileName, setFileName] = useState('')
  const [t] = useTranslation()
  const [file, setFile] = useState<File | null>(null)

  const handleFileSelected = (data: FormData) => {
    const file = data.get('file') as File
    setFileName(file.name)
    setFile(file)
  }

  const handleSubmit = () => {
    if (file) {
      if (isInsert === 'true') {
        const payload = {
          tagCodeIdx: 0,
          lastNameIdx: 1,
          firstNameIdx: 2,
          genderIdx: 3,
          positionIdx: 4,
          shiftTypeIdx: 5,
          contactHoursIdx: 6,
          departmentIdx: 7,
        }
        const formData = new FormData()
        formData.append('file', file)
        formData.append('payload', JSON.stringify(payload))

        importEmployeeTypeInsert(formData)
      } else {
        const payload = {
          idx: 0,
          tagCodeIdx: 1,
          lastNameIdx: 2,
          firstNameIdx: 3,
          genderIdx: 4,
          positionIdx: 5,
          shiftTypeIdx: 6,
          contactHoursIdx: 7,
          departmentIdx: 8,
        }
        const formData = new FormData()
        formData.append('file', file)
        formData.append('payload', JSON.stringify(payload))

        importEmployeeTypeUpdate(formData)
      }
    }
  }

  return (
    <>
      <ImportEmployeesPageHeader
        isInsert={isInsert}
        exportEmployeeInsertExample={exportEmployeeInsertExample}
        exportEmployeeUpdateExample={exportEmployeeUpdateExample}
      />
      <ImportEmployeesUploadCvs loading={loading} onUpload={handleFileSelected} fileName={fileName} />
      <Button disabled={!fileName} type="primary" onClick={handleSubmit} style={{ marginTop: '20px' }}>
        {t('pages.employees.importFromCsv.submit')}
      </Button>
    </>
  )
}

ImportEmployee.displayName = 'ImportEmployee'
export default ImportEmployee
